module.exports = __webpack_public_path__ + "static/media/user_avatar.34641194.png";